<nav class="header navbar navbar-expand-xl fixed-top">
  <div class="header__navbar container">
    <a routerLink="" (click)="scrollToSection('hero')" class="navbar-brand p-0">
      <img
        ngSrc="../../assets/logo/complementary-logo.svg"
        width="173"
        height="34"
        alt="NiceProject Logo"
        class="d-inline-block align-top"
      />
    </a>

    <button
      (click)="toggleNavbarButton()"
      class="header__navbar-toggler navbar-toggler collapsed d-flex d-xl-none flex-column justify-content-around"
      type="button"
      id="navbarNavButton"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="header__navbar-toggler--top-bar"></span>
      <span class="header__navbar-toggler--middle-bar"></span>
      <span class="header__navbar-toggler--bottom-bar"></span>
    </button>

    <div
      class="header__navbar-menu collapse collapsed navbar-collapse"
      id="navbarNavDropdown"
    >
      <div
        class="header__navbar-menu-list navbar__menu d-flex flex-column justify-content-between align-items-center align-items-xl-end container z-2"
      >
        <div
          class="header__navbar-menu-list-links navbar-nav justify-content-xl-end"
        >
          <button
            type="button"
            (click)="closeAndScrollTo('about')"
            class="header__navbar-menu-list-link nav-link p-0"
            >who we are?</button
          >
          <button
            type="button"
            (click)="closeAndScrollTo('tech')"
            class="header__navbar-menu-list-link nav-link p-0"
            >technologies</button
          >
          <a
            (click)="closeAndScrollTo()"
            data-test="go-to-newsroom"
            routerLink="newsroom"
            class="header__navbar-menu-list-link nav-link p-0"
          >
            newsroom</a
          >

          <a
            (click)="closeAndScrollTo()"
            routerLink="careers"
            class="header__navbar-menu-list-link nav-link p-0 position-relative"
          >
            careers
            <span class="header__navbar-menu-list-link-badge">NEW</span>
          </a>

          <button
            (click)="closeAndScrollTo('form')"
            class="header__navbar-menu-list-btn btn btn-menu"
            href="#"
            role="button"
          >
            Contact
          </button>
        </div>
        <div class="header__menu-socials d-flex d-xl-none">
          <div class="header__menu-socials-icons">
            <a
              class="header__menu-socials-link"
              href="https://www.linkedin.com/company/niceproject-sp-z-o-o/mycompany/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                ngSrc="../../assets/icons/linkedin.svg"
                width="34"
                height="34"
                alt="Linkedin icon"
                class="d-inline-block header__menu-socials-icon"
              />
            </a>
          </div>
          <div class="header__menu-socials-icons">
            <a
              class="header__menu-socials-link"
              href="https://www.facebook.com/profile.php?id=100084563584784"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                ngSrc="../../assets/icons/facebook.svg"
                width="34"
                height="34"
                alt="facebookicon"
                class="d-inline-block header__menu-socials-icon"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
